export default __webpack_public_path__ + "static/media/17.2bbdeb03.png";